import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '../../../../Typography';
import { useTableContext } from '../../../contexts';

export const ViewStats = () => {
    const { t } = useTranslation('common');
    const {
        getRowModel,
        props: { dataCount },
        state: {
            pagination: { pageSize },
        },
    } = useTableContext();
    const totalCount = dataCount ?? getRowModel().rows.length;

    return (
        <Typography color="secondary">
            {t('components.table.viewStats', {
                size: Math.min(pageSize, totalCount),
                total: totalCount,
            })}
        </Typography>
    );
};
